import { render, staticRenderFns } from "./ButtonChoice.vue?vue&type=template&id=1324dbeb&scoped=true"
import script from "./ButtonChoice.vue?vue&type=script&lang=js"
export * from "./ButtonChoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1324dbeb",
  null
  
)

export default component.exports